import React from "react";
import "./index.css";

/**
 * Shared eyebrow badge + section heading used by every Hemp Ban section.
 * `children` renders directly under the heading for the sections that carry
 * an intro paragraph (What You Can Do, Before the Changes).
 */
const HempBanSectionHead = ({
  badgeText,
  heading,
  headingId,
  theme = "light",
  children
}) => {
  if (!badgeText && !heading) {
    return null;
  }

  return (
    <div className={`hb-section-head hb-section-head--${theme}`}>
      {badgeText ? <div className="hb-eyebrow">{badgeText}</div> : null}
      {heading ? (
        <h2 className="hb-section-heading" id={headingId}>
          {heading}
        </h2>
      ) : null}
      {children}
    </div>
  );
};

export default HempBanSectionHead;
